import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, AppBar, Toolbar, Typography, ToggleButton, ToggleButtonGroup,
  TextField, Button, Grid, Card, CardContent, Dialog, DialogTitle,
  DialogContent, DialogActions, CircularProgress, IconButton
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { AppContext } from '../context/AppContext';
import InfoDialog from './InfoDialog';
import { getAgeGroup, meetsStandard } from '../utils/dataUtils';

const SwimmerList = () => {
  const {
    course, setCourse, standard, setStandard, searchQuery, setSearchQuery,
    swimmers, standards, loading, error
  } = useContext(AppContext);
  const navigate = useNavigate();
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  const handleCourseChange = (event, newCourse) => {
    if (newCourse) setCourse(newCourse);
  };

  const handleFilterOpen = () => setFilterDialogOpen(true);
  const handleFilterClose = () => setFilterDialogOpen(false);
  const handleStandardSelect = (newStandard) => {
    setStandard(newStandard);
    handleFilterClose();
  };

  const filteredSwimmers = Object.entries(swimmers).filter(([name, data]) => {
    const matchesSearch = name.toLowerCase().includes(searchQuery.toLowerCase());
    if (standard === 'None' || !matchesSearch) return matchesSearch;

    const { Gender, Age } = data.info;
    const ageGroup = getAgeGroup(Age);
    const standardKey = standard === 'Junior Mets' ? 'juniorMets' : 'seniorMets';
    const relevantStandards = standards[standardKey].filter(
      (s) => s.Gender === Gender && (standard === 'Senior Mets' ? s['Age Group'] === 'Open' : s['Age Group'] === ageGroup)
    );

    return data.events.some((event) =>
      relevantStandards.some((std) =>
        std.Event === event.Event && meetsStandard(event.Best_Time, std['Qualifying Time'])
      )
    );
  });

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Container>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h1" sx={{ flexGrow: 1 }}>Swimmer Times</Typography>
          <IconButton onClick={() => setInfoDialogOpen(true)} color="inherit">
            <InfoIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <ToggleButtonGroup
        value={course}
        exclusive
        onChange={handleCourseChange}
        sx={{ my: 2 }}
      >
        <ToggleButton value="SCY">SCY</ToggleButton>
        <ToggleButton value="LCM">LCM</ToggleButton>
      </ToggleButtonGroup>
      <Button
        variant="contained"
        onClick={handleFilterOpen}
        sx={{ mb: 2 }}
      >
        Qualified {standard !== 'None' ? `(${standard.toUpperCase()})` : ''}
      </Button>
      <TextField
        label="Search Swimmers"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
      <Grid container spacing={2}>
        {filteredSwimmers.map(([name, data]) => (
          <Grid item xs={12} sm={6} md={4} key={name}>
            <Card
              onClick={() => navigate(`/swimmer/${encodeURIComponent(name)}`)}
              sx={{ cursor: 'pointer', '&:hover': { boxShadow: 6 } }}
            >
              <CardContent>
                <Typography variant="h2">{name}</Typography>
                <Typography>Age: {data.info.Age}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Dialog open={filterDialogOpen} onClose={handleFilterClose}>
        <DialogTitle>Select Qualification Filter</DialogTitle>
        <DialogContent>
          <Button onClick={() => handleStandardSelect('Junior Mets')}>Junior Mets</Button>
          <Button onClick={() => handleStandardSelect('Senior Mets')}>Senior Mets</Button>
          <Button onClick={() => handleStandardSelect('None')}>None</Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFilterClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <InfoDialog open={infoDialogOpen} onClose={() => setInfoDialogOpen(false)} />
    </Container>
  );
};

export default SwimmerList;